import { useState } from 'react';

import { z } from 'zod';

import { requestPasswordReset as apiRequestPasswordReset } from '../services/passwordService';
import useAuthForm from './useAuthForm';

const DEFAULT_VALUES = {
  email: '',
};

const formSchema = z.object({
  email: z.string().email('Invalid email address.'),
});

const useForgotPasswordForm = () => {
  const [submissionSuccessful, setSubmissionSuccessful] = useState(false);

  const handleSubmit = async (formData, { form }) => {
    setSubmissionSuccessful(false);

    await apiRequestPasswordReset(formData.email);

    setSubmissionSuccessful(true);
    form.reset();
  };

  const authForm = useAuthForm({
    defaultValues: DEFAULT_VALUES,
    onSubmit: handleSubmit,
    schema: formSchema,
  });

  return { ...authForm, submissionSuccessful };
};

export default useForgotPasswordForm;
